import {
    Layout
} from "../../../class/Layout";
import * as utils from "@/components/util/utils";
export class ComponentsInputTableParts extends Layout {
    constructor(data: {
        [key: string]: any
    }) { //构造函数
        super();
        let defaultModel = {
            componentDescription: "表格组件",
            value_default: [],
        }
        this.init(utils.lodash.merge({}, defaultModel, data))
    }
    private _addBtn: boolean = true; //返回值是否是json
    private _editTr: boolean = true; //返回值是否是json
    private _editMove: boolean = false; //返回值是否是json
    private _sort_able: boolean = false; //返回值是否是json
    private _styleEdit: any = {
        width: "1500px"
    };
    private _selectRowOnly: any = null; //共几条数据
    private _selectRowOnlyId: any = null; //共几条数据
    private _selectRow: any = null; //共几条数据
    private _primaryKey: string = "id";
    private _cacheData: any[] = [];
    private _options1: any[] = [];
    private _options2: any[] = [];
    private _options3: any[] = [];
    private _options4: any[] = [];
    private _options5: any[] = [];

    private _file_ol: any = {url:'',text:''};                                                        //ajax
    private _dialogImageUrl: any = null;                                                        //ajax
    private _uploadFiles: any[] = [];                                                        //ajax
    private _file_list: any[] = [];                                                        //ajax
    private _upload_url: string = "/api/upload/defaultUpload";                                                        //ajax
    private _limit: number = 9;                                                        //ajax
    private _isCompress: boolean = false;                                                        //ajax
    private _btn_show: boolean = true;                                                        //ajax
    private _img_show: boolean = false;                                                        //ajax
    private _text_show: boolean = false;                                                        //ajax
    private _multiple: boolean = true;                                                        //ajax
    private _hideUpload: boolean = false;                                                        //ajax
    private _loading: boolean = false;                                                        //ajax
    private _checkTypeName: string = "";                                                        //ajax
    private _text: string = "";                                                        //ajax
    private _dir: string = "";

    initValue() {
        console.log("initValue")
        this.validate_string = "";
        this.value = this.value_default;
    }
    valueFormat(): any {
        console.log("valueFormat")
        return JSON.stringify(this.value)

        // let data: any[] = []
        // if (!this.components) {
        //     return JSON.stringify(data)
        // }
        // for (let key in this.components) {
        //     if (key != "template") {
        //         let val: {
        //             [key: string]: any
        //         } = {}
        //         for (let i = 0; i < this.components[key].length; i++) {
        //             val[this.components[key][i].name] = super.components[key][i].valueFormat()
        //         }
        //         data.push(val)
        //     }
        // }
        // return JSON.stringify(data)
    }
    add() {
        let newValue: any[] = JSON.parse(this.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.value)
        }
        newValue.push({})
        this.value = newValue
    }
    addData() {
        // if(Object.keys(this.value).length <2 || this.cacheData.length == 0){
        //     let newValue: any[] = JSON.parse(this.valueFormat())
        //     this.cacheData = newValue
        // }
        // let newValue: any[] = JSON.parse(this.valueFormat())
        let data1: any[] = [{}];
        // data1.push(this.cacheData)
        let data2: any[] = [];
        data1.map((item: any, index: any) => {
            data2.push(Object.assign({}, item, {
                color: "",
                id: "",
                material_quality: "",
                name: "",
                note: "",
                number: "",
                part_id: "",
                process_part_no: "",
                specifications: "",
                surface_treatment: "",
                url: []
            }))
        })
        // newValue.pop().push(JSON.parse(data))
        this.value = this.cacheData.concat(data2)
        this.cacheData = this.cacheData.concat(data2)
    }
    initCopyComponents() {
        console.log("initCopyComponents")
        console.log(this.value)
        for(let data of this.value){
            let newData =  JSON.parse(data.url)
            if(utils.isNotNull(newData)){
                for(let i=0;i<newData.length;i++){
                    newData[i]['url']="/api/"+newData[i]['url']
                }
            }
            data.url = newData
        }
        console.log(this.value)
    }
    initAjax() {
        //不进行异步请求的组件（临时做法让如果有多个组件参数会有问题）
        console.log("initAjax")
        let that = this
        let params:{ [key: string]: any} = {}
        utils.my_post({apiName:'/partinformation/queryByAll',
            params: params,
            ok: (json:any, dataAll:any) => {
                this.options1 = json
            },err: (json:any, dataAll:any) => {
                that.setAjaxERR(json)
            }
        })
        utils.my_post({apiName:'/partinformation/queryByAll2',
            params: params,
            ok: (json:any, dataAll:any) => {
                this.options2 = json
            },err: (json:any, dataAll:any) => {
                that.setAjaxERR(json)
            }
        })
    }

    setAjaxOK(data: any) {
        this.value = data.list
    }
    setAjaxERR(data: any) {
        this.value = []
        this.value = this.value_default;
    }
    part_id(id:any,index:any){
        console.log(id)
        console.log(index)
        let system_number_id = utils.getPage().getComponents({
            system_id: 'system_number_id1'
        })
        if(utils.isNull(system_number_id)){
            let system_number_id = utils.getPage().getComponents({
                system_id: 'system_number_id'
            })
        }
        utils.my_post({apiName:'/partinformation/queryByAll',
        params: {
                "default_id_": id,
                "sort": index,
                "number_id": system_number_id.value
            },
            ok: (json:any, dataAll:any) => {
                this.value[index].name = json.name
                this.value[index].process_part_no=json.process_part_no,
                this.value[index].specifications=json.specifications,
                this.value[index].material_quality=json.material_quality,
                this.value[index].color= json.color,
                this.value[index].surface_treatment=json.surface_treatment
            },err: (json:any, dataAll:any) => {
                alert("请求出错")
            }
        })
    }
    part_speci(row:any,index:any){
        utils.my_post({apiName:'/partinformation/queryByName',
            params: {name:row.name},
            ok: (json:any, dataAll:any) => {
                this.options3 = json
            },err: (json:any, dataAll:any) => {
                alert("请求出错")
            }
        })
    }
    part_material(row:any,index:any){
        utils.my_post({apiName:'/partinformation/queryBySize',
            params: {
                name:row.name,
                specifications:row.specifications
            },
            ok: (json:any, dataAll:any) => {
                this.options4 = json
            },err: (json:any, dataAll:any) => {
                alert("请求出错")
            }
        })
    }
    part_color(row:any,index:any){
        utils.my_post({apiName:'/partinformation/queryByCaizhi',
            params: {
                name:row.name,
                specifications:row.specifications,
                material_quality:row.material_quality
            },
            ok: (json:any, dataAll:any) => {
                this.options5 = json
            },err: (json:any, dataAll:any) => {
                alert("请求出错")
            }
        })
    }

    part_all(row:any,index:any){
        console.log(row)
        let system_number_id = utils.getPage().getComponents({
            system_id: 'system_number_id1'
        })
        if(utils.isNull(system_number_id)){
            system_number_id = utils.getPage().getComponents({
                system_id: 'system_number_id'
            })
        }
        if(utils.isNotNull(row.color)){
            utils.my_post({apiName:'/partinformation/queryByColor',
            params: {
                sort:index,
                number_id:system_number_id.value,
                name:row.name,
                specifications:row.specifications,
                material_quality:row.material_quality,
                color:row.color
            },
            ok: (json:any, dataAll:any) => {
                this.value[index].name = json.name
                this.value[index].process_part_no=json.process_part_no,
                this.value[index].specifications=json.specifications,
                this.value[index].material_quality=json.material_quality,
                this.value[index].color= json.color,
                this.value[index].surface_treatment=json.surface_treatment
            },err: (json:any, dataAll:any) => {
                alert("请求出错")
            }
        })
        }
        
    }


    get styleEdit(): any {
        return this._styleEdit;
    }

    set styleEdit(value: any) {
        this._styleEdit = value;
    }

    get cacheData(): any[] {
        return this._cacheData;
    }

    set cacheData(value: any[]) {
        this._cacheData = value;
    }

    get options1(): any[] {
        return this._options1;
    }

    set options1(value: any[]) {
        this._options1 = value;
    }

    get options2(): any[] {
        return this._options2;
    }

    set options2(value: any[]) {
        this._options2 = value;
    }

    get options3(): any[] {
        return this._options3;
    }

    set options3(value: any[]) {
        this._options3 = value;
    }

    get options4(): any[] {
        return this._options4;
    }

    set options4(value: any[]) {
        this._options4 = value;
    }

    get options5(): any[] {
        return this._options5;
    }

    set options5(value: any[]) {
        this._options5 = value;
    }

    get selectRowOnly(): any {
        return this._selectRowOnly;
    }
    set selectRowOnly(selectRowOnly: any) {
        this._selectRowOnly = selectRowOnly;
        utils.getStore().addParameter({
            names: [this.name, "selectRowOnly"],
            value: selectRowOnly
        })
        if (utils.isNotNull(selectRowOnly)) {
            this.selectRowOnlyId = selectRowOnly[this.primaryKey];
        }
    }

    /**
     * 主键
     */
    get primaryKey(): string {
        return this._primaryKey;
    }
    set primaryKey(primaryKey: string) {
        this._primaryKey = primaryKey;
    }
    get selectRowOnlyId(): any {
        return this._selectRowOnlyId;
    }
    set selectRowOnlyId(selectRowOnlyId: any) {
        this._selectRowOnlyId = selectRowOnlyId;
    }

    get selectRow(): any {
        return this._selectRow;
    }
    set selectRow(selectRow: any) {
        this._selectRow = selectRow;
        utils.getStore().addParameter({
            names: [this.name, "selectRow"],
            value: selectRow
        })
    }

    get addBtn(): boolean {
        return this._addBtn;
    }

    set addBtn(value: boolean) {
        this._addBtn = value;
    }

    get editTr(): boolean {
        return this._editTr;
    }

    set editTr(value: boolean) {
        this._editTr = value;
    }

    get editMove(): boolean {
        return this._editMove;
    }

    set editMove(value: boolean) {
        this._editMove = value;
    }

    get sort_able(): boolean {
        return this._sort_able;
    }

    set sort_able(value: boolean) {
        this._sort_able = value;
    }

    
    get upload_url(): string {
        return this._upload_url;
    }

    set upload_url(value: string) {
        this._upload_url = value;
    }

    get isCompress(): boolean {
        return this._isCompress;
    }

    set isCompress(value: boolean) {
        this._isCompress = value;
    }

    get multiple(): boolean {
        return this._multiple;
    }

    set multiple(value: boolean) {
        this._multiple = value;
    }

    get hideUpload(): boolean {
        return this._hideUpload;
    }

    set hideUpload(value: boolean) {
        this._hideUpload = value;
    }
    
    get limit(): number {
        return this._limit;
    }

    set limit(value: number) {
        this._limit = value;
    }

    get dialogImageUrl(): any {
        return this._dialogImageUrl;
    }

    set dialogImageUrl(value: any) {
        this._dialogImageUrl = value;
    }

    get uploadFiles(): any[] {
        return this._uploadFiles;
    }

    set uploadFiles(value: any[]) {
        this._uploadFiles = value;
    }

    get checkTypeName(): string {
        return this._checkTypeName;
    }

    set checkTypeName(value: string) {
        this._checkTypeName = value;
    }

    get dir(): string {
        return this._dir;
    }

    set dir(value: string) {
        this._dir = value;
    }

    get btn_show(): boolean {
        return this._btn_show;
    }

    set btn_show(value: boolean) {
        this._btn_show = value;
    }

    get img_show(): boolean {
        return this._img_show;
    }

    set img_show(value: boolean) {
        this._img_show = value;
    }

    get text_show(): boolean {
        return this._text_show;
    }

    set text_show(value: boolean) {
        this._text_show = value;
    }

    get loading(): boolean {
        return this._loading;
    }

    set loading(value: boolean) {
        this._loading = value;
    }

    get file_ol(): any {
        return this._file_ol;
    }

    set file_ol(value: any) {
        this._file_ol = value;
    }

    get text(): string {
        return this._text;
    }

    set text(value: string) {
        this._text = value;
    }

}